import React, { PropsWithChildren } from "react";
import styles from "./Button.module.css";
export const Button: React.FC<
  PropsWithChildren<{
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    variant?: "transparent";
    label?: string;
    type?: "button" | "submit" | "reset";
  }>
> = (props) => {
  const variantClass =
    props.variant === "transparent" ? styles.Transparent : "";
  return (
    <button
      className={`${styles.Button} ${props.className} ${variantClass}`}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.label}
    >
      {props.children}
    </button>
  );
};
